
import React, { useEffect, useState } from 'react'
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { useMainContext } from "../../contexts/MainContext";

//COMPONENTS
import GeneralImporters from './Importers/Index';
import MasterItems from './MasterItems/Index';
import Templates from './Templates/Index';
//ASSETS
import './styles.css';


const DemandImporter = ({ }) => {
  const [preloadReady, setPreloadReady] = useState(false);
  let mainContext = useMainContext();


  useEffect(() => {
    if (preloadReady)
      findDemandImporter();
  }, [preloadReady]);


  const findDemandImporter = async () => {
    mainContext.setIsLoading(true);
    try {
      mainContext.setIsLoading(false);
    }
    catch (error) {/*TODO SOMETHING*/ }
  }

  const getPhaseTemplate = (children) => {
    return <section className="">
      {children}
    </section>
  }


  return (
    <>
      <Switch>
        <Route exact path="/demandImporter/importers">
          {getPhaseTemplate(<GeneralImporters preloadReady={preloadReady} />)}
        </Route>
        <Route exact path="/demandImporter/masterItems">
          {getPhaseTemplate(<MasterItems preloadReady={preloadReady} />)}
        </Route>
        <Route exact path="/demandImporter/templates">
          {getPhaseTemplate(<Templates preloadReady={preloadReady} />)}
        </Route>
      </Switch>
    </>
  )
}
export default DemandImporter;